import { AppBar, Box, Toolbar, Hidden, Grid, Typography } from "@mui/material";
import FerreroLogo from "./FerreroLogo";
import { ReactNode } from "react";
import LanguageSelect from "../layout/LanguageChoiceMenu";

interface Props {
  children?: ReactNode;
}

export default function LoginLayout({ children }: Props) {

  return (
    <div>
   <Box display="flex" >
      <AppBar
        position="fixed"
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 1}}
      >
        <Toolbar sx={{ position: "relative" }}>
        <Grid container>
      <Grid
        item
        md={4}
        xs={11}
        display="flex"
        justifyContent="flex-start"
        alignItems="center"
      >
        <Hidden lgDown>
          <Typography component={"span"} variant="h6" sx={{color: "white"}}>
            Mobile Application Distribution
          </Typography>
        </Hidden>
        <Hidden lgUp>
          <Typography component={"span"} variant="h6" sx={{color: "white"}}>
            MAD
          </Typography>
        </Hidden>
      </Grid>
       <Hidden mdDown>
        <Grid item md={4} sx={{ height: "39px" }}>
         <FerreroLogo color="white" /> 
        </Grid>
        </Hidden> 
        <Grid
          item
          md={4}
          xs={1}
          display="flex"
          alignItems="center"
          justifyContent="flex-end"
        >
          <LanguageSelect /> 
          </Grid>
        </Grid>
        </Toolbar>
      </AppBar>
      <Toolbar></Toolbar>
    </Box>
  </div>
  );
}
